import { Listbox, Transition } from "@headlessui/react";
import { SelectorIcon } from "@heroicons/react/solid";
import axios from "axios";
import { Fragment, useEffect } from "react";
import useState from "react-usestateref";
import backendService from "../services.js/backendService";


function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

function FriendList(props) {
  const [people, setPeople, peopleRef] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [selectedPersons, setSelectedPersons, selectedPersonsRef] = useState(
    []
  );
  const [loading, setLoading, loadingRef] = useState(false);
  useEffect(() => {
    handleFriends();
  }, []);

  const handleFriends = async () => {
    try {
      setLoading(true);
      const res = await axios.get(`${process.env.REACT_APP_URL}/getfriends`, {
        headers: {
          "Content-Type": "application/json",
          "x-auth-token": backendService.getToken(),
        },
      });

      const res2 = await axios.get(`${process.env.REACT_APP_URL}/getgrouplist`, {
        headers: {
          "Content-Type": "application/json",
          "x-auth-token": backendService.getToken(),
        },
      });

      if (res2.data.Status === "No groups.") {
        setPeople(res.data.friends);
      } else {
        setPeople(res.data.friends.concat(res2.data.groups));
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  function isSelected(value) {
    return selectedPersonsRef.current.find((el) => el === value) ? true : false;
  }

  function handleSelect(value) {
    if (!isSelected(value)) {
      const selectedPersonsUpdated = [
        ...selectedPersonsRef.current,
        people.find((el) => el === value),
      ];
      
      setSelectedPersons(selectedPersonsUpdated);
    } else {
      handleDeselect(value);
    }
    setIsOpen(true);
  }

  function handleDeselect(value) {
    const selectedPersonsUpdated = selectedPersons.filter((el) => el !== value);
    setSelectedPersons(selectedPersonsUpdated);
    setIsOpen(true);
  }
  useEffect(() => {
    if (props.friendList && selectedPersons.length > 0) {
      props.friendList(selectedPersons);
    }
  }, [selectedPersons]);

  return (
    <Listbox
      value={selectedPersonsRef.current}
      onChange={(value) => handleSelect(value)}
      open={isOpen}
    >
      {({ open }) => (
        <>
          <div className="mt-1 relative ">
            <Listbox.Button
              onClick={() => setIsOpen(!isOpen)}
              open={isOpen}
              className="appearance-none rounded relative block w-full px-3 py-2 border-[1px] border-palette_color1 bg-palette_color2 placeholder-secondary text-primary rounded-t-md focus:outline-none focus:z-10 sm:text-sm my-1"
            >
              <span className="flex ">
                <span className=" block truncate text-secondary font-robo ">
                  {selectedPersons.length < 1
                    ? loading
                      ? "Loading ..."
                      : "Select persons"
                    : `Selected persons (${selectedPersons.length})`}
                </span>
              </span>
              <span className="ml-3 absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">
                <SelectorIcon
                  className="h-5 w-5 text-primary"
                  aria-hidden="true"
                />
              </span>
            </Listbox.Button>

            <Transition
              show={open}
              as={Fragment}
              leave="transition ease-in duration-100"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <Listbox.Options className="bg-palette_color2 absolute z-10 mt-1 w-full  shadow-md shadow-black max-h-56 rounded-md  text-base overflow-auto focus:outline-none sm:text-sm">
                {peopleRef.current.map((person) => {
                  let selected = isSelected(person);
                  return (
                    <Listbox.Option key={person._id} value={person}>
                      {({ active }) => (
                        <div
                          className={`${
                            active
                              ? "text-palette_color2 bg-palette_color1"
                              : "text-palette_color1 bg-palette_color2"
                          } cursor-default select-none relative py-2 pl-8 pr-4 font-robo `}
                        >
                          <span
                            className={`${selected ? " " : ""} block truncate`}
                          >
                            {person.firstname +
                              " " +
                              person.lastname +
                              " (@" +
                              person.username +
                              ")"}
                          </span>
                          {selected && (
                            <span
                              className={`${
                                active ? "" : "text-palette_color4"
                              } absolute inset-y-0 left-0 flex items-center pl-1.5`}
                            >
                              <svg
                                className="h-5 w-5"
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 20 20"
                                fill="currentColor"
                              >
                                <path
                                  fillRule="evenodd"
                                  d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                  clipRule="evenodd"
                                />
                              </svg>
                            </span>
                          )}
                        </div>
                      )}
                    </Listbox.Option>
                  );
                })}
              </Listbox.Options>
            </Transition>
            <div className="pt-1 text-sm text-primary font-robo ">
              {selectedPersons.length > 0 && (
                <>
                  Selected Members:{" "}
                  {selectedPersons
                    .map(function (person) {
                      return person.firstname + " " + person.lastname;
                    })
                    .join(", ")}
                </>
              )}
            </div>
          </div>
        </>
      )}
    </Listbox>
  );
}

export default FriendList;
